/**
 * カラーピッカーを表示するコンポーネント。
 * https://github.com/bgrins/spectrum
 *
 */
export default {
    // see resources/views/components/_vue_spectrum_color_picker.blade.php
    template: '#spectrum_color_picker_template',
    props: {
        /* 色値 */
        color: {
            type: String,
            require: true
        }
    },
    watch: {
        /**
         * コンポーネント外部からの色変更検知
         * spectrumのsetメソッドで更新しないと適応されない
         */
        color: function() {
            $(this.$refs.colorPicker).spectrum('set', this.color);
        }
    },
    mounted: function() {
        // spectrumの初期化
        $(this.$refs.colorPicker).spectrum({
            appendTo: $(this.$refs.colorPicker).closest('.modal'), // モーダル内に設置されていたらモーダル直下に生成
            showInput: true,
            preferredFormat: 'hex',
            clickoutFiresChange: true,
            showInitial: true,
            chooseText: 'O K',
            cancelText: 'キャンセル',
            showPalette: true,
            showSelectionPalette: true,
            allowEmpty: true,
            palette: [
                ['#212121', '#757575', '#BDBDBD', '#FFFFFF', '#607D8B'],
                ['#9E9E9E', '#7A5648', '#FB5722', '#FC9900', '#D4AD04'],
                ['#FDC00B', '#FEEA3B', '#CCDC3A', '#4CAF50', '#199688'],
                ['#22BCD3', '#1FA9F3', '#2197F2', '#4051B5', '#673AB6'],
                ['#9D28B0', '#E81F63', '#F24437', '#D0021B', '#BCABA4']
            ],
            //閉じた時点のカラーを適応する
            hide: (color) => {
                this.emitChangeColor((color) ? color.toHexString() : '');
            }
        });
    },
    emits: ['update:color'],
    methods: {
        /**
         * spectrumの変更をvueへ通知
         * color 変更後のカラーコード
         */
        emitChangeColor: function(color) {
            this.$emit('update:color', color);
        }
    }
};
